<ng-container *ngIf="header.field =='openPOQty'; else elseTemplate">
    <div class="info-icon cursor-pointer" *ngIf="data[header.field] !== 0">
        {{data[header.field]}} <span>&nbsp;</span><i class="bi bi-info-circle-fill"
            (click)="onOpenDialog(data, header.field)"></i>
    </div>
    <div *ngIf="data[header.field] == 0">
        {{ data[header.field] }}
    </div>
</ng-container>

<ng-template #elseTemplate>
    <div *ngIf="data.shortage_json !== '[]'" class="info-icon cursor-pointer" (mouseleave)="data.showOrders = false">
        {{data[header.field] }}<span>&nbsp;&nbsp;</span><i class="bi bi-info-circle-fill"
            (click)="onOpenDialog(data, header.field)"></i>
    </div>
    <div class="skus-bubble sku-left" *ngIf="
                data.showOrders &&
                showOrderQTY?.length !== 0">
        <table class="show-orders">
            <tr>
                <th>Code</th>
                <th>Qty Shortfall</th>
            </tr>
            <tr *ngFor="let objItem of showOrderQTY">
                <td>{{objItem.code}}</td>
                <td>{{objItem.shortage}}</td>
            </tr>
        </table>
    </div>
    <div *ngIf="data.shortage_json === '[]'">
        {{ data[header.field] }}
    </div>
</ng-template>

<ejs-dialog class="modal rounded" *ngIf="dialogVisible" id="dialog" #ejDialog [isModal]="true" width="500px"
    [visible]="dialogVisible">
    <button (click)="onOverlayClick()" type="button" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
    <div *ngIf="dataSourcePurchaseOrder?.data?.length">
        <h2 class="text-center">Purchase Order Details</h2>
        <h4 class="text-center font-weight-light font-italic">
            Material - {{ infoData.materialCode || infoData.sku }}, Location -
            {{ infoData.locationCode || infoData.location }}
        </h4>
        <div class="table-container">
            <table class="w-100" *ngIf="dataSourcePurchaseOrder" mat-table [dataSource]="dataSourcePurchaseOrder">
                <ng-container *ngFor="
            let disCol of ['code', 'supplierCode', 'qty', 'purchaseOrderDate'];
            let i = index
          " matColumnDef="{{ disCol }}">
                    <th class="header_dialog" mat-header-cell *matHeaderCellDef>
                        {{ modifyName(disCol) }}
                    </th>
                    <td class="text-center" mat-cell *matCellDef="let element">
                        {{ element[disCol] }}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="[
            'code',
            'supplierCode',
            'qty',
            'purchaseOrderDate'
          ]"></tr>
                <tr mat-row *matRowDef="
            let row;
            columns: ['code', 'supplierCode', 'qty', 'purchaseOrderDate']
          "></tr>
            </table>
        </div>
    </div>
</ejs-dialog>